import axios from 'axios';
import { getFirestore, doc, updateDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

  // Base URL for API requests
const API_BASE_URL = import.meta.env.MODE === 'development'
  ? 'http://localhost:5000/api'
  : 'https://notedin.onrender.com/api';

/**
 * Updates the status of an assessment using the given API endpoint.
 *
 * @param {string} assessmentId - The ID of the assessment to be updated.
 * @param {string} status - The new status to set (e.g., 'Accepted', 'Rejected').
 * @param {Object} additionalData - Additional metadata to include in the update.
 */
export const updateAssessmentStatus = (assessmentId, status, additionalData = {}) => {
  if (!assessmentId || !status) {
    throw new Error('Assessment ID and status are required.');
  }

  if (!additionalData.checkpoint_id) {
    throw new Error('Checkpoint ID is required.');
  }

const endpoint = `${API_BASE_URL}/assessment/assessment_requests/${assessmentId}`;
  const currentUser = getAuth().currentUser;

  if (!currentUser) {
    throw new Error('User must be logged in.');
  }

  const db = getFirestore();

  const updateData = {
    status,
    accepted_at: new Date().toISOString(),
    accepted_by: currentUser.uid,
    assessment_id: assessmentId,
    checkpoint_id: additionalData.checkpoint_id,
    invitation_id: additionalData.invitation_id || '',
    item_details: {
      price: additionalData.price || 0,
      images: additionalData.images || [],
      status: 'pending',
    },
    seller_email: currentUser.email,
    seller_id: currentUser.uid,
    seller_role: currentUser.displayName || 'seller',
    seller_created_at: currentUser.metadata.creationTime,
    seller_display_name: currentUser.displayName,
    msg_recipient: currentUser.uid,
    ...additionalData,
  };

  // Fire-and-forget: No need to await
  axios.put(endpoint, updateData)
    .then(response => {
      const assessmentRef = doc(db, 'assessments', assessmentId);
      updateDoc(assessmentRef, {
        seller_email: currentUser.email,
        seller_id: currentUser.uid,
        seller_role: currentUser.displayName || 'seller',
        seller_created_at: currentUser.metadata.creationTime,
        seller_display_name: currentUser.displayName,
        checkpoint_id: additionalData.checkpoint_id,
        msg_recipient: currentUser.uid,
      }).catch(error => {
        console.error(`Error updating Firestore for assessment ${assessmentId}:`, error.message);
      });
    })
    .catch(error => {
      console.error(`Error updating assessment ${assessmentId}:`, error.message);
    });
};
